module.exports = __webpack_public_path__ + "img/about-2-min.2a25e26f.png";